export default function accordions() {
    const balanceExpand = document.querySelector(".expand-balance");
    const balanceCollapse = document.querySelector(".collapse-balance");
    const accordionBalance = document.querySelectorAll(
        ".accordion-balance .gb-accordion__item"
    );
    const balanceToggle = document.querySelectorAll(
        ".accordion-balance .gb-accordion__toggle"
    );

    if (accordionBalance) {
        accordionBalance.forEach((accordion) => {
            balanceExpand.addEventListener("click", function (e) {
                e.preventDefault();
                accordion.classList.add("gb-accordion__item-open");
                balanceToggle.forEach((actoggle) => {
                    actoggle.classList.add("gb-block-is-current");
                    actoggle.attributes["aria-expanded"].value = "true";
                });
            });
            balanceCollapse.addEventListener("click", function (e) {
                e.preventDefault();
                accordion.classList.remove("gb-accordion__item-open");
                balanceToggle.forEach((actoggle) => {
                    actoggle.classList.remove("gb-block-is-current");
                    actoggle.attributes["aria-expanded"].value = "false";
                });
            });
        });
    }

    const fillersExpand = document.querySelector(".expand-fillers");
    const fillersCollapse = document.querySelector(".collapse-fillers");
    const accordionFillers = document.querySelectorAll(
        ".accordion-fillers .gb-accordion__item"
    );
    const fillersToggle = document.querySelectorAll(
        ".accordion-fillers .gb-accordion__toggle"
    );

    if (accordionFillers) {
        accordionFillers.forEach((accordion) => {
            fillersExpand.addEventListener("click", function (e) {
                e.preventDefault();
                accordion.classList.add("gb-accordion__item-open");
                fillersToggle.forEach((actoggle) => {
                    actoggle.classList.add("gb-block-is-current");
                    actoggle.attributes["aria-expanded"].value = "true";
                });
            });
            fillersCollapse.addEventListener("click", function (e) {
                e.preventDefault();
                accordion.classList.remove("gb-accordion__item-open");
                fillersToggle.forEach((actoggle) => {
                    actoggle.classList.remove("gb-block-is-current");
                    actoggle.attributes["aria-expanded"].value = "false";
                });
            });
        });
    }
}
